import type {FieldCheckStatus, FieldCheckStatusRow} from "@sakura-grp/database/services";
import {FieldCheckMark} from "@sakura-grp/ui/field-check-mark";

type Props = {row?: FieldCheckStatusRow; field: "name" | "address"};

export function BusinessCardFieldMark({row, field}: Props) {
  if (!row) return null;
  const detail = row[`${field}_detail`];
  const actorKind = row[`${field}_actor_kind`];
  const actorRole = row[`${field}_actor_role`];
  return <FieldCheckMark fieldLabel={field === "name" ? "氏名" : "住所"} status={row[`${field}_status`] as FieldCheckStatus} actorKind={actorKind === "human" || actorKind === "machine" ? actorKind : null} actorRole={actorRole === "admin" || actorRole === "hostess" ? actorRole : null} actorName={row[`${field}_actor_name`]} checkedAt={row[`${field}_checked_at`]} machineLabel={row[`${field}_machine_label`]} detail={detail && typeof detail === "object" && !Array.isArray(detail) ? detail : null} />;
}

export function needsFieldReview(row: FieldCheckStatusRow | undefined, field: Props["field"]) {
  return !row || ["needs_review", "unverified", "withdrawn"].includes(row[`${field}_status`]);
}

export function BusinessCardFieldReason({row, field}: Props) {
  if (!needsFieldReview(row, field)) return null;
  const detail = row?.[`${field}_detail`];
  const reason = detail && typeof detail === "object" && !Array.isArray(detail) ? (row?.[`${field}_actor_kind`] === "machine" ? detail.reason : detail.note) : null;
  return (
    <p className="text-muted-foreground text-xs">
      {!row ? "確認の状態を読み込み中です" : row[`${field}_status`] === "withdrawn" ? "未確認（戻した）" : row[`${field}_status`] === "needs_review" ? "確認が必要です" : "まだ誰も確認していません"}
      {typeof reason === "string" && reason ? `：${reason}` : ""}
    </p>
  );
}
